import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import { Grid, Typography } from "@material-ui/core/";
import IconButton from "@material-ui/core/IconButton";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import Aux from "../../hoc/Auxilliary";
import { isObjectEmpty } from "../../utils/general";
import SnackBar from "../SnackBar";
import logo from "../../assests/logo-blue.png";
import resetPasswordStyle from "./resetPassword.module.css";
import {
  resetPasswordRequest,
  setMessage,
} from "../../reduxSlices/resetPasswordSlice";
import config from "../../app/config";
import localizedStrings from "../../utils/localize";
import Backdrop from "../Backdrop";
const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  container: {
    margin: "0",
    padding: "1rem 0",
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  formControl: {
    display: "flex",
    width: "100%",
  },
  logoAvatar: {
    width: "100%",
    height: "auto",
    margin: "0 auto",
    paddingBottom: "0.7rem",
  },
}));

function ResetPasswordPage(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const message = useSelector((state) => state.resetPasswordRequest.message);
  const dataFetchingStatus = useSelector(
    (state) => state.resetPasswordRequest.dataFetchingStatus,
  );
  const [errorMessage, setErrorMessage] = useState({
    message: "",
    isError: false,
    field: "",
  });
  const [resetPasswordData, setResetPasswordData] = useState({
    email: window.localStorage.getItem("x-auth-email"),
    currentPassword: "",
    password: "",
    confirmPassword: "",
  });

  const [showSnackBar, setShowSnackBar] = useState({
    status: false,
    message: "",
  });
  const goBack = () => {
    setResetPasswordData({
      email: window.localStorage.getItem("x-auth-email"),
      currentPassword: "",
      password: "",
      confirmPassword: "",
    });
    setErrorMessage({ message: "", isError: false, field: "" });
    props.onClose();
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    if (resetPasswordData.password !== resetPasswordData.confirmPassword) {
      let status = { ...showSnackBar };
      status.status = true;
      status.message = config.CONFIRM_PASSWORD;
      setShowSnackBar(status);
    } else {
      dispatch(resetPasswordRequest(resetPasswordData));
    }
    setResetPasswordData({
      email: window.localStorage.getItem("x-auth-email"),
      currentPassword: "",
      password: "",
      confirmPassword: "",
    });
    setErrorMessage({ message: "", isError: false, field: "" });
    props.onClose();
  };
  const handleSnackBarClose = () => {
    let status = { ...showSnackBar };
    status.status = false;
    setShowSnackBar(status);
    dispatch(setMessage({}));
  };

  useEffect(() => {
    if (!isObjectEmpty(message) && message !== undefined) {
      let status = { ...showSnackBar };
      status.status = true;
      status.message = message;
      setShowSnackBar(status);
    }
  }, [message]);
  const textFieldChangeHandler = (event) => {
    const formData = { ...resetPasswordData };
    formData[event.target.name] = event.target.value.trim();
    //Password validation
    if (event.target.name === "password") {
      const passwordRegex = /^[A-Za-z]\w{8,100}$/;
      if (!passwordRegex.test(event.target.value)) {
        setErrorMessage({
          message:
            "Password must  contain at least one numeric digit, one uppercase and one lowercase letter and at least 8  characters",
          isError: true,
          field: "password",
        });
      } else {
        setErrorMessage({ message: "", isError: false, field: "" });
      }
    }
    if (event.target.name === "confirmPassword") {
      if (formData.confirmPassword !== formData.password) {
        setErrorMessage({
          message: "Passwords does not match",
          isError: true,
          field: "confirmPassword",
        });
      } else {
        setErrorMessage({ message: "", isError: false, field: "" });
      }
    }

    setResetPasswordData(formData);
  };
  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);
  return (
    <Aux>
      <Backdrop show={dataFetchingStatus} />
      <div>
        <SnackBar
          open={showSnackBar.status}
          message={showSnackBar.message}
          handleClose={handleSnackBarClose}
        />
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={props.open}
          closeAfterTransition
          onClose={props.onClose}
        >
          <div className={resetPasswordStyle.resetPasswordContainer}>
            <div className={resetPasswordStyle.resetPasswordContent}>
              <header className={resetPasswordStyle.header}>
                <Typography style={{ marginLeft: "0.5rem" }}>
                  {localizedStrings.changePassword.changePassword}
                </Typography>
              </header>
              <Grid>
                <div className={classes.logoAvatar}>
                  <img src={logo} width="100%" alt="logo" />
                </div>
              </Grid>
              <form className={classes.form} onSubmit={handleSubmit}>
                <TextField
                  label="Confirm Old Password"
                  fullWidth
                  type="password"
                  name="currentPassword"
                  value={resetPasswordData.oldPassword}
                  onChange={textFieldChangeHandler}
                  InputProps={{
                    endAdornment: (
                      <LockOutlinedIcon style={{ color: "#959595" }} />
                    ),
                  }}
                  inputProps={{
                    maxLength: 100,
                    minLength: 8,
                  }}
                />
                <TextField
                  label={localizedStrings.changePassword.newPassword}
                  fullWidth
                  type="password"
                  name="password"
                  value={resetPasswordData.password}
                  onChange={textFieldChangeHandler}
                  InputProps={{
                    endAdornment: (
                      <LockOutlinedIcon style={{ color: "#959595" }} />
                    ),
                  }}
                  inputProps={{
                    maxLength: 100,
                    minLength: 8,
                  }}
                  error={
                    errorMessage.isError && errorMessage.field === "password"
                  }
                  helperText={
                    errorMessage.field === "password"
                      ? errorMessage.message
                      : ""
                  }
                />
                <TextField
                  label="Confirm New Password"
                  fullWidth
                  type="password"
                  name="confirmPassword"
                  value={resetPasswordData.confirmPassword}
                  onChange={textFieldChangeHandler}
                  InputProps={{
                    endAdornment: (
                      <LockOutlinedIcon style={{ color: "#959595" }} />
                    ),
                  }}
                  inputProps={{
                    maxLength: 100,
                    minLength: 8,
                  }}
                  error={
                    errorMessage.isError &&
                    errorMessage.field === "confirmPassword"
                  }
                  helperText={
                    errorMessage.field === "confirmPassword"
                      ? errorMessage.message
                      : ""
                  }
                />
                <br /> <br />
                <div className={classes.formControl}>
                  <Typography
                    component="div"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "1rem",
                      width: "100%",
                    }}
                  >
                    <Button variant="outlined" onClick={goBack} color="primary">
                      {" "}
                      {localizedStrings.changePassword.cancel}
                    </Button>

                    <Button
                      onClick={handleSubmit}
                      disabled={
                        errorMessage.isError ||
                        resetPasswordData.password !==
                          resetPasswordData.confirmPassword
                      }
                      variant="contained"
                      color="primary"
                    >
                      {" "}
                      {localizedStrings.changePassword.submit}
                    </Button>
                  </Typography>
                </div>
              </form>
            </div>
          </div>
        </Modal>
      </div>
    </Aux>
  );
}

export default ResetPasswordPage;
